//src/styles/components/MuiAvatar.js

import palette from "../palette";

const MuiAvatar = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: palette.primary?.alpha?.['20'] || "rgba(25, 118, 210, 0.2)", 
      color: palette.primary?.light || "#4791db", 
      transition: theme?.transitions?.default || "all 0.3s ease" 
    })
  },
};

export default MuiAvatar;